import { useEffect } from 'react';

const defaultDescription =
  'Fundación Tony transforma vidas a través de la educación, la formación en valores y la prevención de adicciones.';

function setMeta(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
}

export default function SEO({
  title = 'Fundación Tony | Transformamos vidas',
  description = defaultDescription,
  path = '/',
  image = '/assets/og-fundacion-tony.jpg',
  schema,
}) {
  useEffect(() => {
    const baseUrl = import.meta.env.VITE_SITE_URL || 'https://fundaciontony.com.mx';
    const canonicalUrl = `${baseUrl}${path}`;
    const imageUrl = image.startsWith('http') ? image : `${baseUrl}${image}`;

    document.title = title;
    document.documentElement.lang = 'es-MX';
    setMeta('meta[name="description"]', { name: 'description', content: description });
    setMeta('meta[property="og:title"]', { property: 'og:title', content: title });
    setMeta('meta[property="og:description"]', { property: 'og:description', content: description });
    setMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' });
    setMeta('meta[property="og:locale"]', { property: 'og:locale', content: 'es_MX' });
    setMeta('meta[property="og:url"]', { property: 'og:url', content: canonicalUrl });
    setMeta('meta[property="og:image"]', { property: 'og:image', content: imageUrl });
    setMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
    setMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: title });
    setMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: description });
    setMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: imageUrl });

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;

    const oldSchema = document.head.querySelector('#structured-data');
    if (oldSchema) oldSchema.remove();
    if (schema) {
      const script = document.createElement('script');
      script.id = 'structured-data';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }, [title, description, path, image, schema]);

  return null;
}
